<div
  class="w-full max-w-[350px] mx-auto p-5 bg-surface rounded-xl shadow-lg border border-border"
>
  <div class="flex justify-between items-center mb-4 gap-4">
    <button
      type="button"
      (click)="prevMonth()"
      class="w-8 h-8 flex shrink-0 items-center justify-center rounded-md bg-primary text-on-primary border-none cursor-pointer text-base transition-transform hover:bg-primary-hover hover:scale-105 active:scale-95"
      aria-label="Previous month"
    >
      &#8592;
    </button>
    <div class="flex gap-2 flex-1 justify-center">
      <select
        [(ngModel)]="viewMonth"
        (ngModelChange)="onMonthChange()"
        aria-label="Select month"
        class="px-2.5 py-1.5 border border-border rounded-md bg-surface text-text text-sm font-medium cursor-pointer outline-none transition-colors hover:border-primary focus:border-primary focus:ring-2 focus:ring-primary-light"
      >
        @for (m of monthOptionsFiltered; track m) {
          <option [value]="m">
            {{ bsMonthNames[m] }}
          </option>
        }
      </select>

      <select
        class="form-select px-2.5 py-1.5 border border-border rounded-md bg-surface text-text text-sm font-medium cursor-pointer outline-none transition-colors hover:border-primary focus:border-primary focus:ring-2 focus:ring-primary-light"
        [(ngModel)]="viewYear"
        (change)="onYearChange()"
      >
        @for (year of yearOptions; track year) {
          <option [value]="year">
            {{ year }}
          </option>
        }
      </select>
    </div>
    <button
      type="button"
      (click)="nextMonth()"
      class="w-8 h-8 flex shrink-0 items-center justify-center rounded-md bg-primary text-on-primary border-none cursor-pointer text-base transition-transform hover:bg-primary-hover hover:scale-105 active:scale-95"
      aria-label="Next month"
    >
      &#8594;
    </button>
  </div>

  <div class="text-center mb-3 text-base font-semibold text-primary py-2">
    {{ monthName }} {{ viewYear }}
  </div>

  <div class="grid grid-cols-7 gap-1 mb-2 text-center">
    @for (wd of nepaliWeekdays; track $index; let i = $index) {
      <span
        class="text-[13px] font-semibold py-2"
        [ngClass]="i === 6 ? 'text-error' : 'text-text-subtle'"
      >
        {{ wd }}
      </span>
    }
  </div>

  <div class="grid grid-cols-7 gap-1 text-center mb-4">
    @for (_ of [].constructor(getFirstDayOfWeek()); track $index) {
      <span></span>
    }
    @for (day of days; track day) {
      <span
        class="flex items-center justify-center py-2 text-sm rounded-md transition-all duration-200"
        [class.bg-primary]="isSelected(day)"
        [class.text-white]="isSelected(day)"
        [class.font-semibold]="isSelected(day)"
        [class.shadow-md]="isSelected(day)"
        [class.text-error]="
          isSaturday(day) && !isSelected(day) && !isDateDisabled(day)
        "
        [class.text-text]="
          !isSaturday(day) && !isSelected(day) && !isDateDisabled(day)
        "
        [class.hover:bg-primary-hover]="
          !isDateDisabled(day) && !isSelected(day)
        "
        [class.hover:text-white]="!isDateDisabled(day) && !isSelected(day)"
        [class.hover:scale-105]="!isDateDisabled(day) && !isSelected(day)"
        [class.cursor-pointer]="!isDateDisabled(day)"
        [class.bg-surface]="isDateDisabled(day)"
        [class.text-text-muted]="isDateDisabled(day)"
        [class.cursor-not-allowed]="isDateDisabled(day)"
        [class.opacity-50]="isDateDisabled(day)"
        [class.line-through]="isDateDisabled(day)"
        (click)="selectDay(day)"
        [attr.aria-label]="'Day ' + day"
        [attr.aria-disabled]="isDateDisabled(day)"
      >
        {{ toNepaliNumber(day) }}
      </span>
    }
  </div>

  <div class="flex justify-between gap-2 pt-3 border-t border-border">
    <button
      type="button"
      class="flex-1 px-4 py-2 border-none rounded-md text-sm font-medium cursor-pointer transition-colors bg-surface-alt text-text-subtle hover:bg-border hover:text-text"
      (click)="clearSelection()"
    >
      Clear
    </button>
    <button
      type="button"
      class="flex-1 px-4 py-2 border-none rounded-md text-sm font-medium cursor-pointer transition-colors bg-primary text-on-primary hover:bg-primary-hover"
      (click)="goToToday()"
    >
      Today
    </button>
  </div>
</div>
